
import { ref, computed } from 'vue'

import icons from '../images/icons/*.svg'

import payload from './payload'

export const demographicStatsReference = '1, 2'

export default ref ( [ {

  id: 1,

  icon: icons[ 'population' ],

  statistic: 'population',

  value: computed( () => payload.value?.pep?.pop?.toLocaleString( 'en' ) || 'N/A' )

}, {

  id: 2,

  icon: icons[ 'median-age' ],

  statistic: 'median age',

  value: computed( () => payload.value?.pep?.medage ? `${ payload.value?.pep?.medage } years` : 'N/A' )

}, {

  id: 5,

  icon: icons[ 'over-65' ],

  statistic: 'persons over 65 years old',

  value: computed( () => 

    payload.value?.pep?.age_65_plus && payload.value?.pep?.pop ?  

    `${ ( payload.value?.pep?.age_65_plus / payload.value?.pep?.pop * 100 ).toFixed( 1 ) }%` : 'N/A' 

  )
  
}, {

  id: 4,

  icon: icons[ 'income' ],

  statistic: 'median household income',

  value: computed( () => payload.value?.acs?.est_houses_median_income_dollars ? `$${ payload.value?.acs?.est_houses_median_income_dollars.toLocaleString( 'en' ) }` : 'N/A' )

}, {

  id: 6,

  icon: icons[ 'housing' ],

  statistic: 'housing',

  value: computed( () => payload.value?.acs?.est_houses_total ? `${ payload.value?.acs?.est_houses_total.toLocaleString( 'en' ) } households` : 'N/A' )

} ] )